import React from 'react'

const Italic = () => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M10 5v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V5z" />
  </svg>
)

export default Italic
